import { datetimeAgo } from "../../../helper";

export default function ReviewersDetails({ reviewer }) {
    const {  feedback, created_at, reviews } = reviewer;

    return (
        <div className="flex flex-col gap-2 p-4 bg-white border-2 border-muted-500">
            <div className="flex items-center justify-start flex-1 gap-2">
                <p className="text-base line-clamp-1">ثمة إضافة هذا الرأي {datetimeAgo(created_at)} </p>
            </div>
            <div className="items-center gap-2 ">
                <div className="text-sm font-bold">مقترح :  </div>
                <div className="text-base">{feedback}</div>
            </div>

            <div className="items-center gap-2 ">
                <div className="text-sm font-bold">الملاحظات :  </div>
                {reviews.map((review, index) => (
                    <div key={index} className="flex flex-col gap-2">
                        <div className="text-base font-semibold">
                            {review.question.text_ar}
                        </div>
                        <div className="flex flex-col gap-1 pl-4">
                            {review?.responses && review.responses.map((response) => (
                                <li key={response.id} className="items-center pr-8 text-base">{response.text_ar}</li>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
